export default __webpack_public_path__ + "static/media/trovity.b6fc258a.svg";